export const AgentPlatformSurface = {
  CONVERSATION: 'CONVERSATION',
  WORKFLOW_NODE: 'WORKFLOW_NODE',
} as const;
export type AgentPlatformSurface =
  (typeof AgentPlatformSurface)[keyof typeof AgentPlatformSurface];

export const AgentPlatformMode = {
  ASK: 'ASK',
  PLAN: 'PLAN',
  AGENT: 'AGENT',
} as const;
export type AgentPlatformMode =
  (typeof AgentPlatformMode)[keyof typeof AgentPlatformMode];

export interface IAgentProfileSummaryView {
  /** A platform enum key, or a `user:<id>` identifier for a database profile. */
  profileKey: string;
  /** The author's own name for the record. Database profiles only; what a picker displays. */
  title?: string;
  /** What the agent is for. */
  description: string;
  owner?: string;
  /** What it hands back. */
  output: string;
  supportedModes: AgentPlatformMode[];
  defaultMode: AgentPlatformMode;
}

export interface IAgentProfileListView {
  profiles: IAgentProfileSummaryView[];
  /** How many are in this page, not how many exist. */
  count: number;
  /** Pass back as `cursor` for the next page. Absent when this page is the last one. */
  cursor?: string;
}
